<template>
  <card class="pt-3 pb-3">
    <list
      :itemLink="itemLink"
      :columns="columns"
      :fields="fields"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :cardLink="cardLink"
      :setLink="setLink"
      :isUpdate="true"
      :isAdd="true"
      :functions="functions"
      @change="change"
      @changeFunction="changeFunction"
    />
  </card>
</template>

<script>
import List from "../components/List";

export default {
  name: "clients-page",
  components: {
    List,
  },
  data() {
    return {
      functions: [{ id: 1, title: "Установить группу" }],
      //end callback data
      /**Меняю ссылки на модель */
      modalCreate: "create-discipline",
      removeLink: "discipline/remove",
      cardLink: "client",
        setLink: "admin/clients/create",
      itemLink: "admin/clients",
      /**Табличные филды */
            fields: [
        {
          label: "Полное имя",
          key: "name",
          type: "text",
        },
        {
          label: "Номер телефона",
          key: "phone",
          type: "phone",
        },
        {
          label: "Группа (статус)",
          key: "group",
          type: "group",
        },
        {
          label: "Устройство",
          key: "device",
          type: "device",
        },
      ],
      columns: [
        {
          key: "phone",
          title: "Номер телефона",
          checkbox: true,
          control: false,
          align: "left",
        },
        {
          key: "name",
          title: "Имя",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "group",
          title: "Группа",
          checkbox: false,
          control: false,
          align: "left",
          type: "object",
        },
        {
          key: "email",
          title: "Эл. почта",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "gender_display",
          title: "Пол",
          checkbox: false,
          control: false,
          align: "left",
        },
        {
          key: "birthday",
          title: "Дата рождения",
          checkbox: false,
          control: false,
          align: "left",
        },
      ],
      value: null,
    };
  },
  created(){
     
  },
  methods: {
    changeFunction(val) {
      if (val == 1) {
        this.$store.dispatch("openModal", {
          model: "group",
          route: "admin/clients/relate/group",
        });

        this.$store.dispatch("selectValue", this.value);
      }
    },
    change(val) {
      this.value = Array.isArray(val) ? val : [val];
    },
  },
};
</script>
<style>
</style>
